import { Button, Typography } from '@arionbanki/arionui';
import { DetailsCard, Footer, Markdown, Modal } from 'components';
import { FLOW_TYPE } from 'consts/flows';
import { getMode } from 'helpers';
import type { EntityProcessInfo } from 'types';
import { useOnboard } from './useOnboard';

export function Onboard() {
	const { flowType, kennitala, person, prefix, t, ...props } = useOnboard();
	return (
		<>
			<Typography className="mb-5" TagName="h3">
				{t(`${prefix}_title`, 'userboard')}
			</Typography>
			{props.unfinishedMifid && (
				<Markdown href={props.mifidURL} linkClassNames="arionui">
					{t('UNFINISHED_MIFID', 'userboard')}
				</Markdown>
			)}
			{props.companyKey && <Typography TagName="p">{t(props.companyKey, 'userboard')}</Typography>}
			<Typography className="mb-5" TagName="p">
				{t(`${prefix}_description`, 'userboard')}
			</Typography>
			{FLOW_TYPE.ES_MV === flowType ? (
				<>
					<Typography className="bold" TagName="p">
						{t('children', 'userboard')}
					</Typography>
					{props.children.map((info: EntityProcessInfo) => (
						<DetailsCard
							checked={kennitala === info.kennitala}
							info={info}
							key={info.kennitala}
							onClick={props.onSelect}
						/>
					))}
				</>
			) : (
				<>
					{person.kennitala && (
						<>
							<Typography className="bold" TagName="p">
								{t('individual', 'userboard')}
							</Typography>
							<DetailsCard checked={kennitala === person.kennitala} info={person} onClick={props.onSelect} />
						</>
					)}
					<Typography className="bold mt-5" TagName="p">
						{t('company', 'userboard')}
					</Typography>
					{props.companies.map((info: EntityProcessInfo) => (
						<DetailsCard
							checked={kennitala === info.kennitala}
							info={info}
							key={info.kennitala}
							onClick={props.onSelect}
						/>
					))}
				</>
			)}
			<Footer handleNext={props.onSubmit} isDisabled={props.isDisabled} next={t('continue')} />
			<Modal
				background="dim"
				className={`col-11 col-md-8 col-lg-6 p-5 theme--${getMode(flowType)}`}
				handleClose={props.redirectToMifid}
				isOpen={props.isModalOpen}
			>
				<button className="close-label bold" onClick={props.redirectToMifid} type="button">
					{t('close_window', 'userboard')}
				</button>
				<Typography className="my-5" TagName="p">
					{t('mifid_required', 'userboard')}
				</Typography>
				<Button onClick={props.redirectToMifid} width="100%">
					{t('OK')}
				</Button>
			</Modal>
		</>
	);
}
